import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function SectionsEditor({ value = [], onChange, testId = "sections" }) {
  const list = value || [];
  const add = () => onChange([...list, { heading: "", body: "" }]);
  const upd = (i, k, v) => onChange(list.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-3" data-testid={testId}>
      <Label>Content sections</Label>
      {list.map((s, i) => (
        <div key={i} className="border border-border rounded-md p-3 space-y-2" data-testid={`${testId}-${i}`}>
          <div className="flex gap-2">
            <Input placeholder="Section heading" value={s.heading} onChange={(e) => upd(i, "heading", e.target.value)} data-testid={`${testId}-heading-${i}`} />
            <Button type="button" size="sm" variant="outline" onClick={() => remove(i)} className="text-red-600 shrink-0"><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
          <Textarea placeholder="Paragraph text…" rows={3} value={s.body} onChange={(e) => upd(i, "body", e.target.value)} data-testid={`${testId}-body-${i}`} />
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={add} data-testid={`${testId}-add`}><Plus className="w-3.5 h-3.5 mr-1" /> Add section</Button>
    </div>
  );
}
